import { theme as laliga } from './theme.laliga';
const themes = {
  laliga,
};

export default themes;
